const resources = {
    linkLead: 'Highly rated by customers for:'
};

module.exports = function getResource(label) {
    return resources[label];
};

